module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      James Becker\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("James Becker is an author of conspiracy, espionage and action thrillers. He spent over twenty years in the Royal Navy’s Fleet Air Arm. Involved in covert operations in many of the world’s hotspots, he brings a high level of detail and authenticity to his work. He also writes action-adventure novels under the name James Barrington and military history under the name Peter Smith in the UK.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/OdrO9z/tc-custom/9781788631730.jpg?1721404434694",
      "alt": "This image is the cover for the book Titanic Secret"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Titanic Secret\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p'), _c('p', [_c('b', [_vm._v("A game of spies takes a tragic turn aboard the famous ocean liner in the international bestselling author’s historical thriller novel.")])]), _c('p', [_vm._v(" On April, 15th, 1912, the RMS "), _c('i', [_vm._v("Titanic ")]), _vm._v("sunk on her maiden voyage to New York. But in James Becker’s fascinating novel, the story of how it happened is an elaborate cover for a much more shocking and dangerous truth. What really destroyed the “unsinkable” ship is a closely guarded military secret . . . ")]), _vm._v(" Among the well-heeled socialites on the transatlantic voyage are three men scheming to create a military alliance between America and Germany. Their goal is to start a war with Great Britain that will finally destroy the British Empire. British agent Alex Tremayne and his American colleague Maria Weston are out to stop the spies from reaching America—a mission that must succeed at any cost . . . \n    "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Canelo Books\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0